/**
 * 报警计划监控时段组件
 * 创建时间：2017-05-11
 * 创建人：zhanlz
 * 修改时间：2017-04-18
 */
<template>
    <div>
		<div class="row">
			<div class="col-sm-12 ">
				<div class="module_title"> <span class="focus_color">请指定报警监控时段</span> </div>
			</div>
		</div>
		<!--监控时段模式-->
		<div v-if="$parent.mode!=2">
			<div class="row">
				<form role="form" class="form-inline">
					<div class="col-sm-2 text-right">
						<div class="form-group pt5px mr30px">
							<label>请选择报警监控时段</label>
						</div>
					</div>
					<div class="col-sm-8">
						<div class="form-group pt5px mr30px">
	                        <label>
	                        	<radio v-model="alarmPeriodInfo.alarmPeriodMode" true-value="9">不限时段</radio>
	    					</label>
	                    </div>
						<div class="form-group pt5px mr30px">
	                        <label>
	                        	<radio v-model="alarmPeriodInfo.alarmPeriodMode" true-value="1">指定周期时段</radio>
	    					</label>
	                    </div>
	                    <div class="form-group pt5px mr30px">
	                        <label>
	                        	<radio v-model="alarmPeriodInfo.alarmPeriodMode" true-value="2">指定日期时段</radio>
	    					</label>
	                    </div>
	                    <div class="form-group pt5px mr30px">
	                        <label>
	                        	<radio v-model="alarmPeriodInfo.alarmPeriodMode" true-value="read">从常用监控时段中读取</radio>
	    					</label>
	                    </div>
	                    <div class="input-group">
	                        <select class="form-control" :disabled="!alarmPeriodUsed" v-model="alarmPeriodInfo.readMonitoringPeriodMode" style="width:150px">
								<option v-for="readMonitoringPeriod in alarmPeriodInfo.readMonitoringPeriodList" :value="readMonitoringPeriod.id" >{{readMonitoringPeriod.name}}</option>
							</select>	
	                        <span class="input-group-btn"> 
	                        	<button type="button" v-if="permission.indexOf('monitorTime_useTimeRead') == -1" class="btn btn-primary" :disabled="!alarmPeriodUsed" @click="readAlarmPeriodMode">读取</button> 
	                        </span>
	                        <span class="input-group-btn"> 
	                        	<button type="button" v-if="permission.indexOf('monitorTime_useTimeDelete') == -1"  class="btn btn-primary" :disabled="!alarmPeriodUsed" @click="confirmDelAlarmPeriodMode">删除</button> 
	                        </span>
	                    </div>
					</div>
					<div class="col-sm-2 text-right">
						<div class="form-group">
	                		<button v-if="alarmPeriodInfo.alarmPeriodMode!=='read'
	                			&&permission.indexOf('monitorTime_add') == -1" type="button" class="btn btn-primary" @click="addAlarmPeriod">添加</button>
	                	</div>
					</div>
				</form>
			</div>
			<br>
			<!--自定义周期时段部分-->
			<div class="row" v-show="alarmPeriodInfo.alarmPeriodMode==='1'">
				<form role="form" class="form-inline grey_box ofh pt10px">
					<div class="col-sm-1 text-center">
						<div class="form-group pt5px">
							<div>
								<checkbox v-model="alarmPeriodInfo.alarmPeriodExclude">除外</checkbox>
							</div>            
						</div>
					</div>
					<div class="col-sm-6">
						<div class="form-group pt5px mr20px">
							<label class="focus_color">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;星期</label>
						</div>
						<div class="form-group pt5px mr20px">
							<div>
								<checkbox v-model="alarmPeriodInfo.weekSel.monday">周一</checkbox>
							</div>
	                    </div>
	                    <div class="form-group pt5px mr20px">
							<div>
								<checkbox v-model="alarmPeriodInfo.weekSel.tuesday">周二</checkbox>
							</div>
	                    </div>
	                    <div class="form-group pt5px mr20px">
							<div>
								<checkbox v-model="alarmPeriodInfo.weekSel.wednesday">周三</checkbox>
							</div>
	                    </div>
	                    <div class="form-group pt5px mr20px">
							<div>
								<checkbox v-model="alarmPeriodInfo.weekSel.thursday">周四</checkbox>
							</div>
	                    </div>
	                    <div class="form-group pt5px mr20px">
							<div>
								<checkbox v-model="alarmPeriodInfo.weekSel.friday">周五</checkbox>
							</div>
	                    </div>
	                    <div class="form-group pt5px mr20px">
							<div>
								<checkbox v-model="alarmPeriodInfo.weekSel.saturday">周六</checkbox>
							</div>
	                    </div>
	                    <div class="form-group pt5px mr20px">
							<div>
								<checkbox v-model="alarmPeriodInfo.weekSel.sunday">周日</checkbox>
							</div>
	                    </div>
					</div>
					<div class="col-sm-5 text-right">
						<div class="form-group pt5px mr30px">
							<label class="focus_color">时段</label>
						</div>
						<div class="form-group pt5px mr30px">
	                        <label>
	                        	<radio v-model="alarmPeriodInfo.alarmPeriodTimeMode" true-value="1">全天</radio>
	    					</label>
	                    </div>
	                    <div class="form-group pt5px mr30px">
	                        <label>
	                        	<radio v-model="alarmPeriodInfo.alarmPeriodTimeMode" true-value="0">自定义</radio>
	    					</label>
	                    </div>
	                    <div class="form-group">
							<span>从</span>
						</div>
	                    <div class="form-group">
	                    	<select class="form-control" :disabled="alarmPeriodTimeSel" v-model="alarmPeriodInfo.alarmPeriodTimeFrom">
								<option v-for="value in timeList">
								    {{ value }}
								</option>
							</select>	
	                    </div>
	                    <div class="form-group">
							<span>时</span>
						</div>
						<div class="form-group">
							<span>&nbsp;至</span>
						</div>
						<div class="form-group">
	                    	<select class="form-control" :disabled="alarmPeriodTimeSel" v-model="alarmPeriodInfo.alarmPeriodTimeTo">
								<option v-for="value in timeList">
								    {{ value }}
								</option>
							</select>	
	                    </div>
	                    <div class="form-group">
							<span>时</span>
						</div>
					</div>
				</form>
			</div>
			<!--自定义日期时段部分-->
			<div class="row" v-show="alarmPeriodInfo.alarmPeriodMode==='2'">
				<form role="form" class="form-inline grey_box ofh pt10px">
					<div class="col-sm-1 text-center">
						<div class="form-group pt5px">
							<div>
								<checkbox v-model="alarmPeriodInfo.alarmPeriodExclude">除外</checkbox>
							</div> 
						</div>
					</div>
					<div class="col-sm-6">
						<div class="form-group pt5px">
							<label style="padding-top:3px;" class="focus_color">日期时段</label>
						</div>
						<div class="form-group pl15px">
							<span>从</span>
						</div>
	                    <div class="form-group">
	                    	<datepicker class="form-control" v-model="alarmPeriodInfo.alarmDateFrom" ref="dateFrom"></datepicker>
	                    </div>
	                    <div class="form-group">
							<span>-</span>
						</div>
						<div class="form-group">
	                    	<datepicker class="form-control" v-model="alarmPeriodInfo.alarmDateTo" ref="dateTo"></datepicker>
	                    </div>
	                    <div class="form-group">
							<span>止</span>
						</div>
					</div>
					<div class="col-sm-5 text-right">
						<div class="form-group pt5px mr30px">
							<label class="focus_color">时段</label>
						</div>
						<div class="form-group pt5px mr30px">
	                        <label>
	                        	<radio v-model="alarmPeriodInfo.alarmPeriodTimeMode" true-value="1">全天</radio>
	    					</label>
	                    </div>
	                    <div class="form-group pt5px mr30px">
	                        <label>
	                        	<radio v-model="alarmPeriodInfo.alarmPeriodTimeMode" true-value="0">自定义</radio>
	    					</label>
	                    </div>
	                    <div class="form-group">
							<span>从</span>
						</div>
	                    <div class="form-group">
	                    	<select class="form-control" :disabled="alarmPeriodTimeSel" v-model="alarmPeriodInfo.alarmPeriodTimeFrom">
								<option v-for="value in timeList">
								    {{ value }}
								</option>
							</select>	
	                    </div>
	                    <div class="form-group">
							<span>时</span>
						</div>
						<div class="form-group">
							<span>&nbsp;至</span>
						</div>
						<div class="form-group">
	                    	<select class="form-control" :disabled="alarmPeriodTimeSel" v-model="alarmPeriodInfo.alarmPeriodTimeTo">
								<option v-for="value in timeList">
								    {{ value }}
								</option>
							</select>	
	                    </div>
	                    <div class="form-group">
							<span>时</span>
						</div>
					</div>
				</form>
			</div>
			<br>
			<!--报警频度部分-->
			<div class="row" v-show="alarmPeriodInfo.alarmPeriodMode!=='read' && alarmFrequency">
				<form role="form" class="form-inline grey_box ofh pt10px">
					<div class="col-sm-11 col-sm-offset-1">
						<div class="form-group pt5px">
							<label style="padding-top:3px;" class="focus_color">报警频度</label>
						</div>
						<div class="form-group pl15px">
							<span>每</span>
						</div>
	                    <div class="form-group">
	                    	<input-number v-model="alarmPeriodInfo.alarmMinuteCount" :min="1" :max="9999" :controls="false" :inputWidth="90"></input-number>
	                    </div>
	                    <div class="form-group mr30px">
							<span>分钟发送</span>
						</div>
						<div class="form-group pt5px mr30px">
	                        <label>
	                        	<radio v-model="alarmPeriodInfo.alarmLimitMode" true-value="0">不限</radio>
	    					</label>
	                    </div>
	                    <div class="form-group pt5px mr30px">
	                        <label>
	                        	<radio v-model="alarmPeriodInfo.alarmLimitMode" true-value="1">限制为</radio>
	    					</label>
	                    </div>
	                    <input-number v-model="alarmPeriodInfo.alarmLimitNum" :min="1" :max="99" :controls="false" :inputWidth="99" :disabled="alarmMinuteStatus"></input-number>
	                    <div class="form-group">
							<span>次报警</span>
						</div>
					</div>
				</form>
			</div>
			<br>
			<div class="row" v-show="alarmPeriodInfo.alarmPeriodMode!=='9' && alarmPeriodInfo.alarmPeriodMode!=='read'">
				<div class="form-horizontal">
					<div class="form-group">
						<label class="col-sm-2 control-label">添加为常用监控时段</label>
						<div class="col-sm-4" >	
							<div class="input-group">
	                            <input type="text" class="form-control" v-model="alarmPeriodInfo.alarmPeriodName"> 
	                            <span class="input-group-btn"> 
	                            	<button type="button" v-if="permission.indexOf('monitorTime_save') == -1" class="btn btn-primary" @click="confirmSaveAlarmPeriodMode">保存</button> 
	                            </span>
	                        </div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<table class="table mt20px table-striped table-bordered">
					<thead>
						<tr>
							<th v-if="$parent.mode!=2"></th>
							<th>条件</th>
							<th>报警日期</th>
							<th>报警时间</th>
							<th>报警频度</th>
							<th>报警次数</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(fileInfo,index) in alarmPeriodInfo.alarmPeriodList" v-bind:key="index">
							<td class="text-center" v-if="$parent.mode!=2">
								<a v-if="permission.indexOf('monitorTime_delete') == -1" class="text-center" @click="removeAlarmPeriod(index)"><i class="glyphicon glyphicon-trash"></i></a>
							</td>
							<td>{{fileInfo.condition}}</td>
							<td>{{fileInfo.alarmdate}}</td>
							<td>{{fileInfo.alarmtime}}</td>
							<td>{{fileInfo.alarmnum}}</td>
							<td>{{fileInfo.alarmcount}}</td>
						</tr>
					</tbody>
			</table>
		</div>
		<!--监控时段保存确认-->
		<tab-modal ref="modalAlarmPeriodSave" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModal('modalAlarmPeriodSave')">
			{{messageStr}}
			<div slot="footer">
				<button @click="closeModal('modalAlarmPeriodSave')" class="btn btn-primary">取消</button>
		        <button @click="saveAlarmPeriodMode" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
		
		<!--报警时段删除确认-->
		<tab-modal ref="modalAlarmPeriodDel" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModal('modalAlarmPeriodDel')">
			{{messageStr}}
			<div slot="footer">
				<button @click="closeModal('modalAlarmPeriodDel')" class="btn btn-primary">取消</button>
		        <button @click="removeAlarmPeriodMode" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
	</div>
</template>

<script>
import Radio from 'components/common/Radio' 
import Checkbox from 'components/common/Checkbox' 
import {TIME_LIST} from 'static/constant'
import TabModal from 'components/common/TabModal'
import InputNumber from 'components/common/InputNumber'
import Datepicker from 'components/common/datepicker/Datepicker' 
import classlist from 'util/classlist'
import { OPERATE_SUCCESS,OPERATE_EXCEPTION,SELECT_ENSURE,DELETE_SUCCESS,INFO_EMPTY,DELETE_ENSURE_INFO,SAVE_ENSURE_INFO} from 'static/message'
export default {
    name: 'AlarmPlanPeriod',
    components: {
    	Radio,
    	Checkbox,
    	TabModal,
    	InputNumber,
    	Datepicker
    },
    props: {
    	parentid: {
			type: String,
			dafault: ""
		}
    },
    data() {
        return {
        	permission:this.$store.state.permission.permission[this.parentid]?this.$store.state.permission.permission[this.parentid]:[],
        	timeList:TIME_LIST,               //时间列表
        	//监控时段
			alarmPeriodInfo: {
				alarmPeriodName: '',		  //监控时段名称
				alarmPeriodMode: '9',		  //监控时段模式
				alarmPeriodExclude: false,	  //时段除外
				weekSel: {
					monday:true,
					tuesday:true,
					wednesday:true,
					thursday:true,
					friday:true,
					saturday:true,
					sunday:true
				},		          //星期选择
				alarmPeriodTimeMode: '1',     //时间选择方式
				alarmMinuteCount:5,           //报警频度分钟数
				alarmLimitMode:'1',           //报警频度限制模式
				alarmLimitNum:2,              //限制次数分钟数
				alarmPeriodList: [],		  //监控时段列表
				alarmPeriodTimeFrom: '00:00', //周期时段时间选择开始
				alarmPeriodTimeTo: '00:00',   //周期时段时间选择结束
				alarmDateFrom: null,          //日期时段开始日期
				alarmDateTo: null,            //日期时段结束日期
				readMonitoringPeriodMode: '', //设置默认监控时段
				readMonitoringPeriodList: [], //读取常用监控时段列表
			},
			scrollTop:'',
			messageStr:''
        };
    },
    created(){
    	this.$emit('input', this.alarmPeriodInfo)
    },
    beforeMount(){
    	this.initEditInfo();
    },
    computed: {
    	//监控时段选择(第四步)
	    alarmPeriodUsed: function () {
	    	return this.alarmPeriodInfo.alarmPeriodMode==='read';
	    },
	    //周期时段时间选择状态(第四步)
	    alarmPeriodTimeSel: function () {
	    	return this.alarmPeriodInfo.alarmPeriodTimeMode==='1';
	    },
	    //限制次数输入框状态(第四步)
	    alarmMinuteStatus: function () {
	    	return this.alarmPeriodInfo.alarmLimitMode==='0';
	    },
	    //报警频度部分状态(第四步)
	    alarmFrequency:function(){
	    	let result = true;
	    	if ((this.alarmPeriodInfo.alarmPeriodMode=="1"||this.alarmPeriodInfo.alarmPeriodMode=="2") && this.alarmPeriodInfo.alarmPeriodExclude){
	    		result = false;
	    	}
	    	return result;
	    }
    },
    methods: {
    	//编辑时初始化信息
    	initEditInfo(){
    		if (this.$parent.mode=='1' || this.$parent.mode=='2'){
    			this.$parent.loadingstatus.period = true;
    			this.$http.get(process.env.API_ROOT + '/alarm/alarm-plans/' + this.$parent.planid + '/timeranges', {params: {planId:this.$parent.planid}})
					.then((response) => {
						if(response.body.success) {
							const res = response.body.data;
							let that = this;
							res.forEach(function(item, i) {
								let weekValue= that.getWeekStringFromcode(item.weekday);
								let period = {};
								if (item.timerangeType==9){
									period = {
										timerangeType:item.timerangeType,
										condition:'不限',														//条件(显示用)
										datestart:item.dateStart,												//开始日期
										dateend:item.dateEnd,													//结束日期
										alarmdate:'不限',														//报警日期(显示用)
										timerangestart:item.timerangeStart,							    		//开始时间
										timerangeend:item.timerangeEnd,					            			//结束时间
										alarmtime:'不限',					    								//报警时间(显示用)
										alarmnum:item.frequency + '分钟',										//报警频度(显示用)
										alarmnumvalue:item.frequency,											//报警频度
										alarmcount:item.upperLimit==99?'不限':item.upperLimit+'次',				//报警次数(显示用)
										alarmcountvalue:item.upperLimit,										//报警次数
										isallday:item.isAllday,													//是否全天
										isexclude:item.isExclude,												//除外/包括
										limitEnable:item.upperLimit==99?1:0,									//启用标志
										weekday:item.weekday
									};
								}else{
									period = {
										timerangeType:item.timerangeType,
										condition:item.isExclude==0?'除外':'包括',								//条件(显示用)
										datestart:item.dateStart,												//开始日期
										dateend:item.dateEnd,													//结束日期
										alarmdate:item.timerangeType == 1?weekValue:item.planDate,				//报警日期(显示用)
										timerangestart:item.timerangeStart,							    		//开始时间
										timerangeend:item.timerangeEnd,					            			//结束时间
										alarmtime:item.isAllday == 1?'全天':item.planTime,					    //报警时间(显示用)
										alarmnum:item.isExclude==0?'':item.frequency + '分钟',					//报警频度(显示用)
										alarmnumvalue:item.frequency,											//报警频度
										alarmcount:item.isExclude==0?'':item.upperLimit==99?'不限':item.upperLimit+'次',				//报警次数(显示用)
										alarmcountvalue:item.upperLimit,										//报警次数
										isallday:item.isAllday,													//是否全天
										isexclude:item.isExclude,												//除外/包括
										limitEnable:item.upperLimit==99?1:0,									//启用标志
										weekday:item.weekday
									};
								}
								
								that.alarmPeriodInfo.alarmPeriodList.push(period);
							})
						} else {
							this.$parent.openModalMsg(response.body.message);
						}
						this.$parent.loadingstatus.period = false;
					}, (response) => {
						this.$parent.openModalMsg(response.body.message);
						this.$parent.loadingstatus.period = false;
					})
					.catch((response) => {
						this.$parent.openModalMsg(OPERATE_EXCEPTION);
						this.$parent.loadingstatus.period = false;
					}	
				)
    		}
    	},
    	//重置周期时段信息
		resetAlarmPeriodInfo(){
	 		this.alarmPeriodInfo.alarmPeriodExclude = true;
       		this.alarmPeriodInfo.weekSel.monday = true;
			this.alarmPeriodInfo.weekSel.tuesday = true;
			this.alarmPeriodInfo.weekSel.wednesday = true;
			this.alarmPeriodInfo.weekSel.thursday = true;
			this.alarmPeriodInfo.weekSel.friday = true;
			this.alarmPeriodInfo.weekSel.saturday = true;
			this.alarmPeriodInfo.weekSel.sunday = true;
			this.alarmPeriodInfo.alarmPeriodTimeMode = "1";
		},
		//重置日期时段信息
		resetAlarmDateInfo(){
			this.alarmPeriodInfo.alarmPeriodExclude = true;
       		this.alarmPeriodInfo.alarmPeriodTimeMode = "1";
       		this.alarmPeriodInfo.alarmDateFrom=null;
       		this.alarmPeriodInfo.alarmDateTo=null;
		},
		//报警时段获取
		initAlarmPeriodMode(){
			this.$http.get(process.env.API_ROOT + '/alarm/alarm-plans/timeranges/', {params: {customerId:this.$store.state.user.groupid}})
				.then((response) => {
					if(response.body.success) {
						const res = response.body.data;
						this.alarmPeriodInfo.readMonitoringPeriodList = res;
					} else {
						this.$parent.openModalMsg(response.body.message);
					}
				}, (response) => {
					this.$parent.openModalMsg(response.body.message);
				})
				.catch((response) => {
					this.$parent.openModalMsg(OPERATE_EXCEPTION);
				}	
			)
		},
    	//监控时段读取
		readAlarmPeriodMode(){
			if(this.alarmPeriodInfo.readMonitoringPeriodMode==""){
				this.$parent.openModalMsg("读取内容不能为空");
				return;
			}
			this.$http.get(process.env.API_ROOT + '/alarm/alarm-plans/timeranges/'+this.alarmPeriodInfo.readMonitoringPeriodMode)
				.then((response) => {
					if(response.body.success) {
						const res = response.body.data;
						this.setAlarmPeriodMode(res);
					} else {
						this.$parent.openModalMsg(response.body.message);
					}
				}, (response) => {
					this.$parent.openModalMsg(response.body.message);
				})
				.catch((response) => {
					this.$parent.openModalMsg(OPERATE_EXCEPTION);
				}	
			)
		},
		//监控时段设置
		setAlarmPeriodMode(val){
			//监控时段模式
			this.alarmPeriodInfo.alarmPeriodMode = val.timerangeType+'';
			if (this.alarmPeriodInfo.alarmPeriodMode==='1'){
				this.alarmPeriodInfo.alarmPeriodExclude = val.isExclude==0?true:false;
				let weekday = val.weekday.split(",");
				this.alarmPeriodInfo.weekSel.monday = weekday[0]==1?true:false;
				this.alarmPeriodInfo.weekSel.tuesday = weekday[1]==1?true:false;
				this.alarmPeriodInfo.weekSel.wednesday = weekday[2]==1?true:false;
				this.alarmPeriodInfo.weekSel.thursday = weekday[3]==1?true:false;
				this.alarmPeriodInfo.weekSel.friday = weekday[4]==1?true:false;
				this.alarmPeriodInfo.weekSel.saturday = weekday[5]==1?true:false;
				this.alarmPeriodInfo.weekSel.sunday = weekday[6]==1?true:false;
				this.alarmPeriodInfo.alarmPeriodTimeMode = val.isAllday+'';
				if (val.isAllday==0){
					this.alarmPeriodInfo.alarmPeriodTimeFrom = val.timerangeStart;
					this.alarmPeriodInfo.alarmPeriodTimeTo = val.timerangeEnd;
				}
				this.alarmPeriodInfo.alarmMinuteCount = val.frequency;
				this.alarmPeriodInfo.alarmLimitMode = val.limitEnable+'';
				this.alarmPeriodInfo.alarmLimitNum = val.upperLimit;
			}
			if (this.alarmPeriodInfo.alarmPeriodMode==='2'){
				this.alarmPeriodInfo.alarmPeriodExclude = val.isExclude==0?true:false;
				this.alarmPeriodInfo.alarmDateFrom = val.dateStart;
				this.alarmPeriodInfo.alarmDateTo = val.dateEnd;
				this.alarmPeriodInfo.alarmPeriodTimeMode = val.isAllday+'';
				if (val.isAllday==0){
					this.alarmPeriodInfo.alarmPeriodTimeFrom = val.timerangeStart;
					this.alarmPeriodInfo.alarmPeriodTimeTo = val.timerangeEnd;
				}
				this.alarmPeriodInfo.alarmMinuteCount = val.frequency;
				this.alarmPeriodInfo.alarmLimitMode = val.limitEnable+'';
				this.alarmPeriodInfo.alarmLimitNum = val.upperLimit;
			}
		},
		//确认删除报警方式
		confirmDelAlarmPeriodMode(){
			if (!this.alarmPeriodInfo.readMonitoringPeriodMode){
				this.$parent.openModalMsg(SELECT_ENSURE);
				return;
			}
			let that = this;
			let name = this.alarmPeriodInfo.readMonitoringPeriodList.find(function(value, index, arr) {
				return value.id == that.alarmPeriodInfo.readMonitoringPeriodMode;
			});
			this.messageStr=DELETE_ENSURE_INFO.replace('{1}','名称').replace('{2}',name.name).replace('{3}','报警时段');
			this.openModal("modalAlarmPeriodDel");
		},
		//报警时段删除
		removeAlarmPeriodMode(){
			this.$parent.loadingstatus.period = true;
			this.closeModal("modalAlarmPeriodDel");
			this.$http.delete(process.env.API_ROOT + '/alarm/alarm-plans/timeranges/'+this.alarmPeriodInfo.readMonitoringPeriodMode)
			.then((response) => {
				if(response.body.success) {
					this.$parent.openModalMsg(DELETE_SUCCESS);
					this.alarmPeriodInfo.readMonitoringPeriodMode='';
					this.initAlarmPeriodMode();
				} else {
					this.$parent.openModalMsg(response.body.message);
				}
				this.$parent.loadingstatus.period = false;
			}, (response) => {
				this.$parent.openModalMsg(response.body.message);
				this.$parent.loadingstatus.period = false;
			})
			.catch((response) => {
				this.$parent.openModalMsg(OPERATE_EXCEPTION);
				this.$parent.loadingstatus.period = false;
			})
		},
		//确认保存报警时段
		confirmSaveAlarmPeriodMode(){
			if (this.alarmPeriodInfo.alarmPeriodName.trim()===""){
				this.$parent.openModalMsg(INFO_EMPTY.replace('{1}','监控时段名称'));
				return;
			}
			if(this.alarmPeriodInfo.alarmPeriodMode=="read"){
				this.$parent.openModalMsg(INFO_EMPTY.replace('{1}','监控时段类型'));
				return;
			}
			this.messageStr=SAVE_ENSURE_INFO.replace('{1}','名称').replace('{2}',this.alarmPeriodInfo.alarmPeriodName).replace('{3}','监控时段');
			this.openModal("modalAlarmPeriodSave");
		},
		//报警时段保存
		saveAlarmPeriodMode(){
			this.$parent.loadingstatus.period = true;
			this.closeModal("modalAlarmPeriodSave");
			
			//星期数据
			let weekDayValue = this.getWeekValue(this.alarmPeriodInfo.weekSel);
			let param ={
				name:this.alarmPeriodInfo.alarmPeriodName,
				customerId:this.$store.state.user.groupid,
				timerangeList:[{
					timerangeType:this.alarmPeriodInfo.alarmPeriodMode,
					isExclude:this.alarmPeriodInfo.alarmPeriodExclude?0:1,
					weekDay:weekDayValue,
					isAllday:this.alarmPeriodInfo.alarmPeriodTimeMode,
					timerangeStart:this.alarmPeriodInfo.alarmPeriodTimeFrom,
					timerangeEnd:this.alarmPeriodInfo.alarmPeriodTimeTo,
					dateStart:this.alarmPeriodInfo.alarmDateFrom == null?'1984-01-25':this.alarmPeriodInfo.alarmDateFrom,
					dateEnd:this.alarmPeriodInfo.alarmDateTo == null?'1984-01-25':this.alarmPeriodInfo.alarmDateTo,
					limitEnable:this.alarmPeriodInfo.alarmLimitMode,
					frequency:this.alarmPeriodInfo.alarmMinuteCount,
					upperLimit:this.alarmPeriodInfo.alarmLimitNum,
				}]
			}
			this.$http.post(process.env.API_ROOT + '/alarm/alarm-plans/timeranges/', param)
			.then((response) => {
				if(response.body.success) {
					this.$parent.openModalMsg(OPERATE_SUCCESS);
					this.initAlarmPeriodMode();
				} else {
					this.$parent.openModalMsg(response.body.message);
				}
				this.$parent.loadingstatus.period = false;
			}, (response) => {
				this.$parent.openModalMsg(response.body.message);
				this.$parent.loadingstatus.period = false;
			})
			.catch((response) => {
				this.$parent.openModalMsg(OPERATE_EXCEPTION);
				this.$parent.loadingstatus.period = false;
			})
		},
		//添加监控时段检查
		addCheck(){
			let result = true;
			if (this.alarmPeriodInfo.alarmPeriodMode=="9"){
				let count = this.alarmPeriodInfo.alarmPeriodList.filter(function (element) {  
			    	return element.timerangeType== '9';  
				});  
				if (count.length>0){
					this.$parent.openModalMsg("不限时段只能存在一个");
					result = false;
				}
			}
			if (this.alarmPeriodInfo.alarmPeriodMode=="2"){
				if (this.alarmPeriodInfo.alarmDateFrom==null||this.alarmPeriodInfo.alarmDateTo==null){
					this.$parent.openModalMsg("日期时段未选择");
					result = false;
				}
				if (this.alarmPeriodInfo.alarmDateFrom > this.alarmPeriodInfo.alarmDateTo){
					this.$parent.openModalMsg("开始日期不能大于结束日期");
					result = false;
				}
			}
			if ((this.alarmPeriodInfo.alarmPeriodMode=="1" || this.alarmPeriodInfo.alarmPeriodMode=="2") &&  this.alarmPeriodInfo.alarmPeriodTimeMode=='0'){
				if (this.alarmPeriodInfo.alarmPeriodTimeFrom==''||this.alarmPeriodInfo.alarmPeriodTimeTo==''){
					this.$parent.openModalMsg("时间未选择");
					result = false;
				}
				if (this.alarmPeriodInfo.alarmPeriodTimeFrom >= this.alarmPeriodInfo.alarmPeriodTimeTo){
					this.$parent.openModalMsg("结束时间必须大于开始时间");
					result = false;
				}
			}
			
			return result
		},
		//添加监控时段
		addAlarmPeriod() {
			//添加监控时段检查
			if (!this.addCheck()){
				return;
			}
			
			let condition,alarmdate,alarmtime,alarmnum,alarmcount;
			
			if(this.alarmPeriodInfo.alarmPeriodMode=="9"){
				condition="不限";
				alarmdate="不限";
				alarmtime="不限";
				//报警频度
				alarmnum = this.alarmPeriodInfo.alarmMinuteCount+"分钟";
				//报警次数
				alarmcount = this.alarmPeriodInfo.alarmLimitMode == "0"?"不限":this.alarmPeriodInfo.alarmLimitNum+"次";
			}else{
				if (this.alarmPeriodInfo.alarmPeriodExclude){
					//报警频度
					alarmnum = "";
					//报警次数
					alarmcount = "";
				}else{
					//报警频度
					alarmnum = this.alarmPeriodInfo.alarmMinuteCount+"分钟";
					//报警次数
					alarmcount = this.alarmPeriodInfo.alarmLimitMode == "0"?"不限":this.alarmPeriodInfo.alarmLimitNum+"次";
				}
				//条件
				condition = this.alarmPeriodInfo.alarmPeriodExclude?"除外":"包括";
				//报警日期
				if (this.alarmPeriodInfo.alarmPeriodMode=="1"){
					alarmdate = this.getWeekString();
				}else{
					alarmdate = this.alarmPeriodInfo.alarmDateFrom +"~"+this.alarmPeriodInfo.alarmDateTo;
				}
				//报警时间
				alarmtime = this.alarmPeriodInfo.alarmPeriodTimeMode=="1"?"全天":this.alarmPeriodInfo.alarmPeriodTimeFrom+"~"+this.alarmPeriodInfo.alarmPeriodTimeTo;
			}
			
			let weekday = this.getWeekValue(this.alarmPeriodInfo.weekSel);
			let period = {
				timerangeType:this.alarmPeriodInfo.alarmPeriodMode,
				condition:condition,													//条件(显示用)
				datestart:this.alarmPeriodInfo.alarmDateFrom,							//开始日期
				dateend:this.alarmPeriodInfo.alarmDateTo,								//结束日期
				alarmdate:alarmdate,													//报警日期(显示用)
				timerangestart:this.alarmPeriodInfo.alarmPeriodTimeFrom,				//开始时间
				timerangeend:this.alarmPeriodInfo.alarmPeriodTimeTo,					//结束时间
				alarmtime:alarmtime,													//报警时间(显示用)
				alarmnum:alarmnum,														//报警频度(显示用)
				alarmnumvalue:this.alarmPeriodInfo.alarmMinuteCount,					//报警频度
				alarmcount:alarmcount,													//报警次数(显示用)
				alarmcountvalue:this.alarmPeriodInfo.alarmLimitNum,						//报警次数
				isallday:this.alarmPeriodInfo.alarmPeriodTimeMode,						//是否全天
				isexclude:this.alarmPeriodInfo.alarmPeriodExclude?0:1,					//除外/包括
				limitEnable:this.alarmPeriodInfo.alarmLimitMode,						//启用标志
				weekday:weekday
			};
			this.alarmPeriodInfo.alarmPeriodList.push(period);
		},
		getWeekStringFromcode(weekday){
			if (weekday==''){
				return '';
			}
			let strWeek='';
			let arrayWeek = weekday.split(",");
			if (arrayWeek[0]==1){
				strWeek+="周一 "
			}
			if (arrayWeek[1]==1){
				strWeek+="周二 "
			}
			if (arrayWeek[2]==1){
				strWeek+="周三 "
			}
			if (arrayWeek[3]==1){
				strWeek+="周四 "
			}
			if (arrayWeek[4]==1){
				strWeek+="周五 "
			}
			if (arrayWeek[5]==1){
				strWeek+="周六 "
			}
			if (arrayWeek[6]==1){
				strWeek+="周日 "
			}
			return strWeek
		},
		getWeekString(){
			let strWeek='';
			if (this.alarmPeriodInfo.weekSel.monday){
				strWeek+="周一 "
			}
			if (this.alarmPeriodInfo.weekSel.tuesday){
				strWeek+="周二 "
			}
			if (this.alarmPeriodInfo.weekSel.wednesday){
				strWeek+="周三 "
			}
			if (this.alarmPeriodInfo.weekSel.thursday){
				strWeek+="周四 "
			}
			if (this.alarmPeriodInfo.weekSel.friday){
				strWeek+="周五 "
			}
			if (this.alarmPeriodInfo.weekSel.saturday){
				strWeek+="周六 "
			}
			if (this.alarmPeriodInfo.weekSel.sunday){
				strWeek+="周日 "
			}
			return strWeek
		},
		getWeekValue(){
			//星期数据
			let weekDayValue = [];
			let that = this;
			Object.keys(this.alarmPeriodInfo.weekSel).forEach(function(trait){
				weekDayValue.push(that.alarmPeriodInfo.weekSel[trait]?1:0);
            });
			return weekDayValue.join(",");
		},
		removeAlarmPeriod(index){
			this.alarmPeriodInfo.alarmPeriodList.splice(index,1);
		},
		// 消息弹出框相关 
		openModal(ref) {
        	this.$refs[ref].open();
        	classlist.toggleScroll('close','#'+this.parentid,this);
    	},
    	closeModal(ref){
    		this.$refs[ref].close();
    		classlist.toggleScroll('open','#'+this.parentid,this);
    	},
    },
    watch: {
    	alarmPeriodInfo:{
    		handler(newValue, oldValue) {
　　　　　　		this.$emit('input', this.alarmPeriodInfo)
　　　　		},
			deep:true
    	},
    	//时间选择方式
       "alarmPeriodInfo.alarmPeriodTimeMode": function () {
       		if(this.alarmPeriodInfo.alarmPeriodTimeMode=="1"){
       			this.alarmPeriodInfo.alarmPeriodTimeFrom = '00:00';
       			this.alarmPeriodInfo.alarmPeriodTimeTo = '00:00';
       		}
       },
	    //监控时段
	    "alarmPeriodInfo.alarmPeriodMode": function () {
	       if(this.alarmPeriodInfo.alarmPeriodMode=="read"){
	       		this.initAlarmPeriodMode();
	       		
	       }
        },
        //监控次数限制
        "alarmPeriodInfo.alarmLimitMode": function () {
        	 if(this.alarmPeriodInfo.alarmLimitMode==="0"){
        	 	this.alarmPeriodInfo.alarmLimitNum = 1;
        	 }
        },
    }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// AlarmPlanPeriod.vue?dcf7efa6